'use client'

import { useRouter } from 'next/navigation'
import { useAuth } from '@/lib/auth/working-context'
import { useState } from 'react'
import { Spinner } from '@/components/ui/spinner'

interface HelpNavButtonProps {
  children: React.ReactNode
  className?: string
  fallbackHref?: string
}

export function HelpNavButton({ 
  children, 
  className = '', 
  fallbackHref = '/' 
}: HelpNavButtonProps) {
  const { user, loading } = useAuth()
  const router = useRouter()
  const [isNavigating, setIsNavigating] = useState(false)

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    setIsNavigating(true)
    
    // Determine destination based on auth state
    const destination = user ? '/dashboard' : '/'
    
    // Use router.push for instant navigation without page reload
    router.push(destination)
  }

  // Show loading state if auth is still being determined
  const showLoadingState = loading || isNavigating

  return (
    <>
      {/* Client-side button with intelligent routing */}
      <button
        onClick={handleClick}
        className={className}
        disabled={showLoadingState}
      >
        {showLoadingState ? (
          <span className="flex items-center justify-center">
            <Spinner size="sm" className="-ml-1 mr-2 text-current" />
            Načítám...
          </span>
        ) : (
          children
        )}
      </button>

      {/* Fallback for users without JavaScript */}
      <noscript>
        <a href={fallbackHref} className={className}>
          {children}
        </a>
      </noscript>
    </>
  )
}